function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* global MD5 */
(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   * A place for general utility functions.
   */
  factory('Utils', ['$document', '$window', function ($document, $window) {
    var qualifyURL = function qualifyURL(url) {
      var a = $document.get(0).createElement('a');
      a.href = url;
      return a.href;
    };
    var parseISO8601DateTime = function parseISO8601DateTime(string) {
      var regexp = "([0-9]{4})(-([0-9]{2})(-([0-9]{2})" + "(T([0-9]{2}):([0-9]{2})(:([0-9]{2})(\\.([0-9]+))?)?" + "(Z|(([-+])([0-9]{2}):([0-9]{2})))?)?)?)?";
      var d = string.match(new RegExp(regexp));
      var offset = 0;
      var date = new Date(d[1], 0, 1);
      if (d[3]) {
        date.setMonth(d[3] - 1);
      }
      if (d[5]) {
        date.setDate(d[5]);
      }
      if (d[7]) {
        date.setHours(d[7]);
      }
      if (d[8]) {
        date.setMinutes(d[8]);
      }
      if (d[10]) {
        date.setSeconds(d[10]);
      }
      if (d[12]) {
        date.setMilliseconds(Number("0." + d[12]) * 1000);
      }
      if (d[14]) {
        offset = Number(d[16]) * 60 + Number(d[17]);
        offset *= d[15] === '-' ? 1 : -1;
      }
      offset -= date.getTimezoneOffset();
      var time = Number(date) + offset * 60 * 1000;
      var dateToReturn = new Date();
      dateToReturn.setTime(Number(time));
      return dateToReturn;
    };
    var parseISO8601DurationString = function parseISO8601DurationString(ds) {
      var match = ds.match(/^P([^tT]*)T?([^tT]*)$/i);
      var duration = {};
      var _parseInt = function _parseInt(s) {
        return typeof s === 'undefined' || s === '' ? 0 : parseInt(s);
      };
      var _parseFloat = function _parseFloat(s) {
        return typeof s === 'undefined' || s === '' ? 0 : parseFloat(s);
      };
      if (match) {
        var date = match[1];
        var time = match[2];

        // note: the date part of duration strings is not supported by xapi/tincan
        if (date && date !== '') {
          duration.date = {};
          var dMatch = date.match(/^(?:(\d*)y)?(?:(\d*)m)?(?:(\d*)w)?(?:(\d*)d)?/i);
          if (dMatch) {
            duration.date.years = _parseInt(dMatch[1]);
            duration.date.months = _parseInt(dMatch[2]);
            duration.date.weeks = _parseInt(dMatch[3]);
            duration.date.days = _parseInt(dMatch[4]);
          }
        }
        if (time && time !== '') {
          duration.time = {};
          var tMatch = time.match(/^(?:(\d*)h)?(?:(\d*)m)?(?:(\d*\.?\d*)s)?/i);
          if (tMatch) {
            duration.time.hours = _parseInt(tMatch[1]);
            duration.time.minutes = _parseInt(tMatch[2]);
            duration.time.seconds = _parseFloat(tMatch[3]);
          }
        }
      }
      return duration;
    };
    var convertISO8601DurationToCentiseconds = function convertISO8601DurationToCentiseconds(ds) {
      var d = this.parseISO8601DurationString(ds);
      var s = 0;

      // note: the date part of duration strings is not supported by xapi/tincan

      if (d.time.hours) {
        s += d.time.hours * 60 * 60;
      }
      if (d.time.minutes) {
        s += d.time.minutes * 60;
      }
      if (d.time.seconds) {
        s += d.time.seconds;
      }
      return s * 100;
    };

    // ref: http://stackoverflow.com/a/1293163/2343
    var csvToArray = function CSVToArray(strData) {
      var strDelimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
      // Check to see if the delimiter is defined. If not,
      // then default to comma.
      strDelimiter = strDelimiter || ",";

      // Create a regular expression to parse the CSV values.
      var objPattern = new RegExp(
      // Delimiters.
      "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
      // Quoted fields.
      "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
      // Standard fields.
      "([^\"\\" + strDelimiter + "\\r\\n]*))", "gi");

      // Create an array to hold our data. Give the array
      // a default empty first row.
      var arrData = [[]];

      // Create an array to hold our individual pattern
      // matching groups.
      var arrMatches = null;

      // Keep looping over the regular expression matches
      // until we can no longer find a match.
      var loops = 0;
      while (true && loops < 10000) {
        loops += 1;
        arrMatches = objPattern.exec(strData);
        if (!arrMatches) {
          break;
        }

        // Get the delimiter that was found.
        var strMatchedDelimiter = arrMatches[1];

        // Check to see if the given delimiter has a length
        // (is not the start of string) and if it matches
        // field delimiter. If id does not, then we know
        // that this delimiter is a row delimiter.
        if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
          // Since we have reached a new row of data,
          // add an empty row to our data array.
          arrData.push([]);
        }
        var strMatchedValue;

        // Now that we have our delimiter out of the way,
        // let's check to see which kind of value we
        // captured (quoted or unquoted).
        if (arrMatches[2]) {
          // We found a quoted value. When we capture
          // this value, unescape any double quotes.
          strMatchedValue = arrMatches[2].replace(new RegExp("\"\"", "g"), "\"");
        } else {
          // We found a non-quoted value.
          strMatchedValue = arrMatches[3];
        }

        // Now that we have our value string, let's add
        // it to the data array.
        arrData[arrData.length - 1].push(strMatchedValue);
      }

      // Return the parsed data.
      return arrData;
    };

    //WARNING: GLOBAL REF TO Base64, from lib/base64.js
    var base64encode = function base64encode(string) {
      return Base64.encode(string);
    };

    //WARNING: GLOBAL REF TO MD5, from lib/md5.js
    var md5 = function md5(string) {
      if (typeof string === "undefined" || string === null) {
        return null;
      }
      return MD5(string);
    };
    var dictionaryLength = function dictionaryLength(dict) {
      var len = 0;
      for (var k in dict) {
        if (dict.hasOwnProperty(k)) {
          len = len + 1;
        }
      }
      return len;
    };
    var isArray = function isArray(obj) {
      return obj && Object.prototype.toString.call(obj) === '[object Array]';
    };
    var ifEmptyThenNull = function ifEmptyThenNull(collection) {
      return _.isEmpty(collection) ? null : collection;
    };
    var capitalize = function capitalize(str) {
      if (typeof str === "undefined" || str === null) {
        return null;
      }
      return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var capitalizeEachWord = function capitalizeEachWord(str) {
      if (!str) {
        return null;
      }
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    };
    var randomId = function randomId(length) {
      length = length || 10;
      var chars = [];
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < length; i++) {
        chars.push(possible.charAt(Math.floor(Math.random() * possible.length)));
      }
      return chars.join('');
    };
    var removeAt = function removeAt(arr, index) {
      if (index < 0 || index > arr.length) {
        return arr;
      }
      return arr.slice(0, index).concat(arr.slice(index + 1, arr.length));
    };
    var getIdFromURL = function getIdFromURL(url) {
      return parseInt(url.substr(url.lastIndexOf("/") + 1));
    };
    var getIdFromCreatedResponse = function getIdFromCreatedResponse(response) {
      var location = response.headers("location");
      return this.getIdFromURL(location);
    };
    var splitArrayIntoRows = function splitArrayIntoRows(items, numberOfColumns) {
      if (!items || !items.length) {
        return [];
      }
      var rows = [];
      for (var i = 0; i < items.length; i += numberOfColumns) {
        var row = [];
        for (var j = i; j < i + numberOfColumns && j < items.length; j++) {
          row.push(items[j]);
        }
        rows.push(row);
      }
      return rows;
    };
    var getQueryVariable = function getQueryVariable(variable) {
      var query = $window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
          return decodeURIComponent(pair[1]);
        }
      }
    };
    var decodeHtmlEntity = function decodeHtmlEntity(str) {
      str = str || "";
      return str.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      });
    };
    var encodeHtmlEntity = function encodeHtmlEntity(str) {
      var buf = [];
      for (var i = str.length - 1; i >= 0; i--) {
        buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
      }
      return buf.join('');
    };

    // strips HTML tags from string
    var stripHTML = function stripHTML(str) {
      str = str || "";
      return str.replace(/<[^>]*>/g, "");
    };
    var toCamelCase = function toCamelCase(str) {
      if (typeof str === "undefined" || str === null) {
        return null;
      }
      return jQuery.camelCase(str.replace(/ /g, "-").toLowerCase());
    };
    var appendParams = function appendParams(url, params) {
      if (_.isEmpty(params)) {
        return url;
      }
      var toString = Object.prototype.toString;
      var paramArray = [];

      // Go through param map, skipping undefined or null params,
      // and expanding arrays into multiple params of the same name
      _.each(params, function (v, k) {
        if (typeof v === "undefined" || v === null) {
          return;
        } else if (toString.call(v) === "[object Array]") {
          _.each(v, function (v2) {
            paramArray.push([k, v2]);
          });
        } else {
          paramArray.push([k, v]);
        }
      });

      // One more check, to see if we never came up with any params...
      if (paramArray.length === 0) {
        return url;
      }

      // Ok, turn our params into an actual query string now...
      var qs = _.map(paramArray, function (pair) {
        var key = pair[0];
        var value = pair[1];
        if (toString.call(value) === "[object Object]") {
          value = JSON.stringify(value);
        }
        return [key, encodeURIComponent(value)].join("=");
      }).join("&");
      var separator = url.indexOf("?") >= 0 ? "&" : "?";
      return url + separator + qs;
    };
    var wordWrap = function wordWrap(text, width, height) {
      var words = text.split(/[\s]+/);
      var str = [];
      _.each(words, function (word) {
        //each line must be less than the width
        //what if the word is >= width?
        if (word.length > width) {
          //if this word is a url just break into pieces otherwise add "-"
          for (var i = 0; i < word.length; i += width) {
            str.push(word.substr(i, width));
          }
        } else if (str.length > 0 && str[str.length - 1].length + word.length < width) {
          str[str.length - 1] = str[str.length - 1] + ' ' + word;
        } else {
          str.push(word);
        }
      });
      if (typeof height === 'number' && Number.isFinite(height) && height >= 0) {
        str = str.slice(0, height);
      }
      return str.join('<br/>');
    };

    /**
     * This function just provides a convenient way to try to access properties that may or may not exist.
     *
     * ex. cfg.cardToProvide.configuration.params.defaultSort
     * If you try to access 'defaultSort' like this you could get an error.
     *
     * But with this:
     *      _try(function() { return cfg.cardToProvide.configuration.params.defaultSort }, '-measure[0].value');
     *
     * you can avoid doing something like:
     *
     * cfg && cfg.cardToProvide && cfg.cardToProvide.configuration && cfg.cardToProvide.configuration.params... etc
     *
     * NOTE: This would be even cleaner with Babel + ES6:
     *      _try(() => cfg.cardToProvide.configuration.params.defaultSort, '-measure[0].value');
     *
     * @param fn - Callback function that should return the property to be accessed
     * @param fallback - The fallback value to default to if the check should fail
     * @returns {*}
     */
    var _try = function _try(fn, fallback) {
      try {
        return fn();
      } catch (err) {
        return fallback;
      }
    };
    var existy = function existy(x) {
      return x !== undefined && x !== null;
    };
    var isNull = function isNull(x) {
      return x === null;
    };
    var isUndefined = function isUndefined(x) {
      return x === undefined;
    };
    var isEmpty = function isEmpty(x) {
      return this.existy(x) && (x.length === 0 || Object.getOwnPropertyNames(x).length === 0);
    };

    /*
     * 'getIn' traverses an object by selecting nested properties, defined by a given list of property
     * names (a path), until it finds a value at the end of the path or cannot follow the path any
     * further (i.e. some identifier in the path is not defined
     *
     * ex. find a nested property
     *      getIn({'a': {'b': {'x': 0}}}, ['a', 'b', 'x']) => 0
     *
     * ex. path is not defined in given context
     *      getIn({}, ['a']) => undefined
     *      getIn({'a': {'b': {'x': 0}}}, ['a', 'b', 'y']) => undefined
     *      getIn({'a': {'b': {'x': 0}}}, ['a', 'b', 'y'], {alt: -1}) => -1
     *
     * @param context - an object which may contain a value at the specified path
     * @param path - an array of property names (strings)
     * @param alt - a value to return if path is not defined in context ('undefined' by default)
     */

    var parsePath = function parsePath(path) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$acc = _ref.acc,
        acc = _ref$acc === void 0 ? [] : _ref$acc,
        _ref$separator = _ref.separator,
        separator = _ref$separator === void 0 ? '.' : _ref$separator;
      var separatorPattern = new RegExp("[".concat(separator, "\\[]"), 'g');
      var parseNextKey = function parseNextKey(i) {
        if (i >= path.length) {
          return {
            key: null,
            i: i
          };
        }
        if (path[i] === '[') {
          var j = path.indexOf(']', i + 1);
          var key = parseInt(path.slice(i + 1, j));
          return {
            key: key,
            i: j + 1
          };
        }
        if (path[i] === separator) {
          var _j = path.slice(i + 1).search(separatorPattern);
          var k = _j < 0 ? path.length : i + 1 + _j;
          var _key = path.slice(i + 1, k);
          return {
            key: _key,
            i: k
          };
        } else {
          var _j2 = path.slice(i).search(separatorPattern);
          var _k = _j2 < 0 ? path.length : i + _j2;
          var _key2 = path.slice(i, _k);
          return {
            key: _key2,
            i: _k
          };
        }
      };
      var _parsePathAPS = function parsePathAPS(i, acc) {
        var nxt = parseNextKey(i);
        if (nxt.key === null) {
          return acc;
        }
        return _parsePathAPS(nxt.i, acc.concat([nxt.key]));
      };
      return _parsePathAPS(0, acc);
    };
    var getIn = function getIn(context, path) {
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        alt = _ref2.alt,
        _ref2$separator = _ref2.separator,
        separator = _ref2$separator === void 0 ? '.' : _ref2$separator;
      if (typeof path === 'string') {
        return getIn(context, parsePath(path, {
          separator: separator
        }), {
          alt: alt
        });
      }
      return context && path.reduce(function (o, k) {
        if (!!o) {
          return o[k];
        }
      }, context) || alt;
    };

    // does 'context' have a given property
    var has = function has(context, path) {
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref3$separator = _ref3.separator,
        separator = _ref3$separator === void 0 ? '.' : _ref3$separator;
      return this.existy(this.getIn(context, path, {
        alt: false,
        separator: separator
      }));
    };

    // is a given property truthy in 'context'
    var check = function check(context, path) {
      var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref4$separator = _ref4.separator,
        separator = _ref4$separator === void 0 ? '.' : _ref4$separator;
      return !!this.getIn(context, path, {
        alt: false,
        separator: separator
      });
    };

    /*
     * 'setIn' traverses an object by selecting nested properties, defined by a given list of property
     * names (a path), setting the value at the end of the path if it can be reached**.
     *
     * **   set force=true to force setIn to create nested empty objects in the given context, so that
     *      it can set the given value at the end of the path
     *
     * ex.  set a nested property
     *      let ob = {'a': {'b': {'x': 0}}}
     *      setIn(ob, ['a', 'b', 'x'], 1)
     *      ob => {'a': {'b': {'x': 1}}}
     *      setIn(ob, ['a', 'b', 'y'], 2)
     *      ob => {'a': {'b': {'x': 1, 'y': 2}}}
     *      setIn(ob, ['a', 'c', 'notReachable'], true)
     *      ob => {'a': {'b': {'x': 1, 'y': 2}}}
     *
     * ex.  force-set an unreachable nested property
     *      let ob = {'x': {}}
     *      setIn(ob, ['x', 'y', 'z'], true, {force: true})
     *      ob => {'x': {'y': {'z': true}}}
     *
     * @param context - an object which may contain a value at the specified path
     * @param path - an array of property names (strings)
     * @param value - a value to put at the end of the given path
     * @param force - should 'setIn' create the given path if it doesn't exist?
     */
    var updateIn = function updateIn(context) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key3 = 1; _key3 < _len; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      this.setIn.apply(this, [context].concat(args));
      return context;
    };
    var setIn = function setIn(context, path, value) {
      var _ref5 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref5$force = _ref5.force,
        force = _ref5$force === void 0 ? false : _ref5$force,
        _ref5$separator = _ref5.separator,
        separator = _ref5$separator === void 0 ? '.' : _ref5$separator;
      if (typeof path === 'string') {
        return this.setIn(context, parsePath(path, {
          separator: separator
        }), value, {
          force: force
        });
      }
      if (_typeof(context) === 'object' && Array.isArray(path) && path.length > 0) {
        var i = path.length - 1;
        var k = path[i];
        var o = path.slice(0, i).reduce(function (o, k) {
          if (typeof o !== 'undefined') {
            if (typeof o[k] === 'undefined' && force) {
              o[k] = {};
            }
            return o[k];
          }
        }, context);
        if (o) {
          o[k] = value;
        }
      }
    };

    /*
     * given a predicate, 'p', and an array, 'xs', 'decons' deconstructs the given array, producing an
     * array that contains the following:
     *
     *  'a' -- the first element in 'xs' that satisfies 'p'
     *  'd' -- a shallow copy of 'xs', without 'a'
     *  'cons' -- a function which, given 'a' and 'd' produces a shallow copy of 'xs'
     *
     *      * if there is not an element of 'xs' that satisfies 'p', then 'a' will be 'undefined',
     *        and cons will append it's first argument to the end of a copy of 'xs'
     *      * 'p' may also be an index, in which case decons will pluck the element at that position in
     *        'xs', and the resulting 'cons' function will put an element back in that position (if 'p'
     *        is negative, cons will put its first arg at the end of its result
     */
    var decons = function decons(p, xs) {
      var i = typeof p === 'function' ? xs.findIndex(p) : p;
      var a = xs[i];
      var d = i < 0 ? xs : xs.slice(0, i).concat(xs.slice(i + 1));
      var append = function append(_a, _d) {
        return typeof _a === 'undefined' ? _d : _d.concat([_a]);
      };
      var insert = function insert(_a, _i, _d) {
        return _d.slice(0, _i).concat([_a]).concat(_d.slice(_i));
      };
      var cons = function cons(_a, _d) {
        return i < 0 ? append(_a, _d) : insert(_a, i, _d);
      };
      return [a, d, cons];
    };
    var forEach = function forEach(xs, f) {
      if (!Array.isArray(xs)) {
        throw new Error('forEach: the first argument to \'forEach\' must be an Array');
      }
      if (typeof f !== 'function') {
        throw new Error('forEach: the second argument to \'forEach\' must be a Function');
      }
      return xs.forEach(f);
    };
    var sortBy = function sortBy(xs, p) {
      if (!Array.isArray(xs)) {
        throw new Error('sortBy: the first argument to \'sortBy\' must be an Array');
      }
      if (typeof p !== 'function') {
        throw new Error('sortBy: the second argument to \'sortBy\' must be a Function');
      }
      return _.sortBy(xs, p);
    };
    var contains = function contains(xs, y) {
      if (!Array.isArray(xs)) {
        throw new Error('contains: the first argument to \'contains\' must be an Array');
      }
      return xs.indexOf(y) >= 0;
    };
    var map = function map(xs, f) {
      if (!Array.isArray(xs)) {
        throw new Error('map: the first argument to \'map\' must be an Array');
      }
      if (typeof f !== 'function') {
        throw new Error('map: the second argument to \'map\' must be a Function');
      }
      return xs.map(f);
    };
    var flatMap = function flatMap(xs, f) {
      if (!Array.isArray(xs)) {
        throw new Error('flatMap: the first argument to \'map\' must be an Array');
      }
      if (typeof f !== 'function') {
        throw new Error('flatMap: the second argument to \'map\' must be a Function');
      }
      return xs.reduce(function (acc, x) {
        return acc.concat(f(x));
      }, []);
    };
    var filter = function filter(xs, p) {
      if (!Array.isArray(xs)) {
        throw new Error('filter: the first argument to \'filter\' must be an Array');
      }
      if (typeof p !== 'function') {
        throw new Error('filter: the second argument to \'filter\' must be a Function');
      }
      return _.filter(xs, p);
    };
    var reduce = function reduce(xs, f, y) {
      if (!Array.isArray(xs)) {
        throw new Error('reduce: the first argument to \'reduce\' must be an Array');
      }
      if (typeof f !== 'function') {
        throw new Error('reduce: the second argument to \'reduce\' must be a Function');
      }
      return xs.reduce(f, y);
    };
    var find = function find(xs, p) {
      return _.find(xs, p);
    };
    var findIndex = function findIndex(xs, p) {
      if (!Array.isArray(xs)) {
        throw new Error('findIndex: the first argument to \'findIndex\' must be an Array');
      }
      if (typeof p !== 'function') {
        throw new Error('findIndex: the second argument to \'findIndex\' must be a Function');
      }
      return xs.findIndex(p);
    };
    var findWhere = function findWhere(xs, ps) {
      return _.findWhere(xs, ps);
    };
    var chain = function chain(x) {
      return _.chain(x);
    };
    var debounce = function debounce(f, i) {
      return _.debounce(f, i);
    };
    var _clamp = function clamp(min, max) {
      if (Array.isArray(min)) {
        return _clamp.apply(void 0, _toConsumableArray(min));
      }
      if (!existy(min) && !existy(max)) {
        return function (n) {
          return n;
        };
      }
      return function (n) {
        if (!existy(n)) {
          return n;
        }
        if (existy(min) && n < min) {
          return min;
        }
        if (existy(max) && n > max) {
          return max;
        }
        return n;
      };
    };

    // (x -> a, x -> b, ... x -> n) -> [a, b, ... n]
    var fork = function fork() {
      for (var _len2 = arguments.length, fs = new Array(_len2), _key4 = 0; _key4 < _len2; _key4++) {
        fs[_key4] = arguments[_key4];
      }
      return function () {
        for (var _len3 = arguments.length, args = new Array(_len3), _key5 = 0; _key5 < _len3; _key5++) {
          args[_key5] = arguments[_key5];
        }
        return fs.map(function (f) {
          return f.apply(void 0, args);
        });
      };
    };

    /*
     cata: ((x -> boolean, x -> a), ... (x -> boolean, x -> n)) -> x -> a | ... | n
     cata, short for catamorphism, is an abstraction of reasoning by cases. in the simplest sense, cata
    is a data structure that could be interpreted as a switch statement or a sequence of if statements
     so this simple branching function
     (x) => {
        if (p(x)) return f(x)
        if (q(x)) return g(x)
        if (r(x)) return h(x)
    }
     is equivalent to the following catamorphism
     cata([p, f], [q, g], [r, h])
     cata also may also be used to represent list folds, recursion on any target type.  following is a trivial
    example of list recursion
     const length = cata([ls => ls.length === 0, ls => 0], [ls => ls.length > 0, ([a, ...d]) => 1 + length(d)])
      */
    var cata = function cata() {
      for (var _len4 = arguments.length, cs = new Array(_len4), _key6 = 0; _key6 < _len4; _key6++) {
        cs[_key6] = arguments[_key6];
      }
      return function (x) {
        var c = cs.find(function (_ref6) {
          var _ref7 = _slicedToArray(_ref6, 1),
            p = _ref7[0];
          return p(x);
        });
        if (!!c) {
          return c[1](x);
        }
      };
    };

    // assignMethods(o, ms) :
    //
    // each m in ms should have one of the following forms:
    // - [m: string, f: function, b: boolean]
    // - [m: string, f: function]
    //
    // we add each 'f' as an enumerable property, 'm', of 'o', that cannot be overwritten or deleted
    // if 'b' exists and is 'true', we bind 'this' to 'o'
    //
    // ex.
    // > let baz = assignMethods({}, [
    //      ['foo', (x) => `foo: ${x}`],
    //      ['bar', function (x, y) { return `bar: ${y} (${this.foo(x)})` }, true]
    //   ])
    // > baz.foo('x')
    // 'foo: x'
    // > baz.bar('y')
    // 'bar: y (foo: x)'
    //
    var assignMethods = function assignMethods(o, ms) {
      return ms.reduce(function (acc, _ref8) {
        var _ref9 = _slicedToArray(_ref8, 3),
          m = _ref9[0],
          f = _ref9[1],
          b = _ref9[2];
        return Object.defineProperty(o, m, {
          value: !!b ? f.bind(o) : f,
          writable: false,
          enumerable: true,
          configurable: false
        });
      }, o);
    };

    /*
     An EVENT REGISTER is an abstraction over events, observers (listeners), and behaviors
      A user can define once how observers should be notified of an event (in the `addObserver` method provided to
     `createEventRegister`).  An observer is then defined just by the events it observes (and any other info the
     user would like to attach to an observer), and behaviors are defined just in terms of their observers.
      Abstracting notifications away from behaviors means we can reuse behaviors in different event systems--in the
     example below you'll see the standard javascript `addEventListener` mode, and in `report-links.js` you'll see
     how to use an EVENT REGISTER to factor `high-charts' events out of `bar-chart.js`.  It should be straightforward
     to adapt this to angular's event system as well, i.e. allow us to gradually factor some angular logic out of
     watershed's logic.
      `makeEventHandler` constructs an immutable object of the form:
        `{event: String, f: (module: Object) -> (...params: [Object]) -> () }`
      `createEventRegister` takes an object, `module`, and a function, `addObserver`, as its arguments
        and provides an interface--consisting of `EventHandler`, `registerEventHandlers`, and `registerObservers`--
        that may be used to create and store event-handlers, and to define event observers.
      - `module` is a plain object that may contain any methods, constants, state, etc. required by an `EventHandler`
       at runtime
      - `addObserver` is a method of the form `(context, event, handleEvent, params) -> ()`
        - `context` is an plain object (it may be the observer itself)
        - `event` is a string (like 'click', 'mouseDown', ...)
        - `handleEvent` is method (a `createEventRegister` internal method) that determines an observer's reaction to an event
        - `params` is a plain object with any global or instance parameters (provided by `registerObservers`)
      `registerEventHandlers` stores event handlers to the private `eventHandlers` Map
      `registerObservers` identifies observers and uses the `addObserver` method to augment their behavior
      ----------
     e.g.
     below is a sketch of how you might use this (also see report-links.js & bar-chart.js)
     ----------
     const module = {
        ...any methods your event handlers might need access to...
        doSomething: (config, scope, id, domEvent) => ...
     }
      const addObserver = (ob, event, handleEvent, {id, params}) =>
            ob.addEventListener(event, function (e) {
                handleEvent(event, this, Object.assign({id}, params, {domEvent: e}));
            });
      const {registerEventHandlers, registerObservers} = Utils.createEventRegister(module, addObserver);
      registerEventHandlers(             <-- note `addObserver` determines the second part of a handler's signature
        makeEventHandler('click', (module) => (scope, {id, config, domEvent}) => {
            module.doSomething(config, scope, id, domEvent);
        }));
      registerObservers(anObject, [
            {id: 1, events: ['click']}, <-- note these observer specifications can contain anything as long as one
            {id: 2, events: ['click']}      of those things is an array of strings called 'events'.  anything
        ], {config: $scope.config});        included will also be available to `addObserver`
     ----------
    */
    var makeEventHandler = function makeEventHandler(event, f) {
      return Object.freeze({
        event: event,
        f: f
      });
    };
    var createEventRegister = function createEventRegister(module, addObserver) {
      var eventHandlers = new Map();
      var registerEventHandlers = function registerEventHandlers() {
        for (var _len5 = arguments.length, handlers = new Array(_len5), _key7 = 0; _key7 < _len5; _key7++) {
          handlers[_key7] = arguments[_key7];
        }
        return handlers.forEach(function (_ref0) {
          var event = _ref0.event,
            f = _ref0.f;
          return eventHandlers.set(event, f(module));
        });
      };
      var handleEvent = function handleEvent(event) {
        // note we determine behavior at runtime, and there is no current prohibition against overriding an
        //  already registered event handler--this may be used for good or ill.
        var f = eventHandlers.get(event);
        if (typeof f === 'function') {
          for (var _len6 = arguments.length, params = new Array(_len6 > 1 ? _len6 - 1 : 0), _key8 = 1; _key8 < _len6; _key8++) {
            params[_key8 - 1] = arguments[_key8];
          }
          f.apply(void 0, params);
        }
      };
      var registerObservers = function registerObservers(context) {
        var observers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return (
          // note each observer `spec` must contain an array of events (e.g. 'click', 'MouseOver', etc), and
          //  `addObserver` will have access to each observer's `spec` and anything in `params`
          observers.forEach(function (spec) {
            return spec.events.forEach(function (event) {
              return addObserver(context, event, handleEvent, Object.assign({}, spec, {
                params: params
              }));
            });
          })
        );
      };
      return {
        registerEventHandlers: registerEventHandlers,
        registerObservers: registerObservers
      };
    };
    var coalesceActivity = function coalesceActivity(activityObj) {
      return coalesce(activityObj.name, activityObj.activityId);
    };
    var coalesce = function coalesce(value1, value2) {
      return !value1.replace(/\s/g, '').length ? value2 : value1;
    };
    return assignMethods({}, [['qualifyURL', qualifyURL, true], ['parseISO8601DateTime', parseISO8601DateTime, true], ['parseISO8601DurationString', parseISO8601DurationString, true], ['convertISO8601DurationToCentiseconds', convertISO8601DurationToCentiseconds, true], ['csvToArray', csvToArray, true], ['base64encode', base64encode, true], ['md5', md5, true], ['dictionaryLength', dictionaryLength, true], ['isArray', isArray, true], ['ifEmptyThenNull', ifEmptyThenNull, true], ['capitalize', capitalize, true], ['capitalizeEachWord', capitalizeEachWord, true], ['randomId', randomId, true], ['removeAt', removeAt, true], ['getIdFromURL', getIdFromURL, true], ['getIdFromCreatedResponse', getIdFromCreatedResponse, true], ['splitArrayIntoRows', splitArrayIntoRows, true], ['getQueryVariable', getQueryVariable, true], ['decodeHtmlEntity', decodeHtmlEntity, true], ['encodeHtmlEntity', encodeHtmlEntity, true], ['stripHTML', stripHTML, true], ['toCamelCase', toCamelCase, true], ['appendParams', appendParams, true], ['wordWrap', wordWrap, true], ['_try', _try, true], ['existy', existy, true], ['isNull', isNull, true], ['isUndefined', isUndefined, true], ['isEmpty', isEmpty, true], ['getIn', getIn, true], ['has', has, true], ['check', check, true], ['setIn', setIn, true], ['updateIn', updateIn, true], ['decons', decons, true], ['forEach', forEach, true], ['sortBy', sortBy, true], ['contains', contains, true], ['map', map, true], ['flatMap', flatMap, true], ['filter', filter, true], ['reduce', reduce, true], ['find', find, true], ['findIndex', findIndex, true], ['findWhere', findWhere, true], ['chain', chain, true], ['debounce', debounce, true], ['fork', fork], ['cata', cata], ['assignMethods', assignMethods], ['clamp', _clamp], ['makeEventHandler', makeEventHandler], ['createEventRegister', createEventRegister], ['coalesce', coalesce, true], ['coalesceActivity', coalesceActivity, true]]);
  }]);
})();
